export var HiMedical = [
    { HiMedical: { '500': 131.36, '1200': 71.96 } },
    { HiMedical: { '500': 93.55, '1200': 50.54 } },
    { HiMedical: { '500': 80.39, '1200': 45.11 } },
    { HiMedical: { '500': 86.02, '1200': 48.51 } },
    { HiMedical: { '500': 92.28, '1200': 52.27 } },
    { HiMedical: { '500': 99.11, '1200': 56.35 } },
    { HiMedical: { '500': 106.36, '1200': 60.67 } },
    { HiMedical: { '500': 113.89, '1200': 65.1 } },
    { HiMedical: { '500': 120.98, '1200': 69.25 } },
    { HiMedical: { '500': 127.25, '1200': 72.89 } },
    { HiMedical: { '500': 132.43, '1200': 75.87 } },
    { HiMedical: { '500': 135.98, '1200': 77.87 } },
    { HiMedical: { '500': 137.8, '1200': 78.87 } },
    { HiMedical: { '500': 138.09, '1200': 78.95 } },
    { HiMedical: { '500': 138.14, '1200': 79.03 } },
    { HiMedical: { '500': 138.21, '1200': 79.15 } },
    { HiMedical: { '500': 138.3, '1200': 79.33 } },
    { HiMedical: { '500': 138.43, '1200': 79.56 } },
    { HiMedical: { '500': 138.59, '1200': 79.84 } },
    { HiMedical: { '500': 138.76, '1200': 80.15 } },
    { HiMedical: { '500': 138.95, '1200': 80.49 } },
    { HiMedical: { '500': 139.16, '1200': 80.86 } },
    { HiMedical: { '500': 139.39, '1200': 81.28 } },
    { HiMedical: { '500': 139.64, '1200': 81.74 } },
    { HiMedical: { '500': 139.93, '1200': 82.24 } },
    { HiMedical: { '500': 140.23, '1200': 82.79 } },
    { HiMedical: { '500': 140.57, '1200': 83.4 } },
    { HiMedical: { '500': 142.84, '1200': 84.06 } },
    { HiMedical: { '500': 148.27, '1200': 84.79 } },
    { HiMedical: { '500': 154.59, '1200': 87.55 } },
    { HiMedical: { '500': 161.67, '1200': 91.67 } },
    { HiMedical: { '500': 169.51, '1200': 96.24 } },
    { HiMedical: { '500': 177.87, '1200': 101.13 } },
    { HiMedical: { '500': 186.77, '1200': 106.35 } },
    { HiMedical: { '500': 196.16, '1200': 111.88 } },
    { HiMedical: { '500': 206.0, '1200': 117.71 } },
    { HiMedical: { '500': 216.61, '1200': 123.97 } },
    { HiMedical: { '500': 228.07, '1200': 130.69 } },
    { HiMedical: { '500': 240.22, '1200': 137.8 } },
    { HiMedical: { '500': 253.12, '1200': 145.29 } },
    { HiMedical: { '500': 266.76, '1200': 153.18 } },
    { HiMedical: { '500': 280.87, '1200': 161.34 } },
    { HiMedical: { '500': 295.31, '1200': 169.7 } },
    { HiMedical: { '500': 310.14, '1200': 178.3 } },
    { HiMedical: { '500': 325.37, '1200': 187.15 } },
    { HiMedical: { '500': 340.94, '1200': 196.23 } },
    { HiMedical: { '500': 357.06, '1200': 205.65 } },
    { HiMedical: { '500': 373.87, '1200': 215.46 } },
    { HiMedical: { '500': 391.25, '1200': 225.58 } },
    { HiMedical: { '500': 408.99, '1200': 235.88 } },
    { HiMedical: { '500': 427.06, '1200': 246.31 } },
    { HiMedical: { '500': 445.14, '1200': 256.7 } },
];
